import { ChangeEvent, useCallback } from 'react';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { UserFormData } from '../../add-user-dialog/user-form-page';

import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';

interface EmployeeIdTextFieldProps {
  watch: UseFormWatch<UserFormData>;
  setValue: UseFormSetValue<UserFormData>;
  disabled: boolean;
}

export default function EmployeeIdTextField({
  watch,
  setValue,
  disabled,
}: EmployeeIdTextFieldProps) {
  const externalIds = watch('externalIds');

  const handleOrgIdChange = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const organizationIds =
        externalIds?.filter((id) => id.type === 'organization') || [];
      const hasOrganizationIds = organizationIds.length > 0;

      if (hasOrganizationIds) {
        if (e.target.value === '' && organizationIds.length === 1) {
          setValue(
            'externalIds',
            externalIds?.filter((id) => id.type !== 'organization'),
            { shouldDirty: true }
          );
          return;
        } else {
          let foundOrgId = false;

          setValue(
            'externalIds',
            externalIds?.map((id) => {
              if (id.type === 'organization' && !foundOrgId) {
                foundOrgId = true;
                return { ...id, value: e.target.value };
              }
              return id;
            }),
            { shouldDirty: true }
          );
        }
      } else {
        setValue(
          'externalIds',
          [
            ...(externalIds || []),
            {
              type: 'organization',
              customType: '',
              value: e.target.value,
            },
          ],
          { shouldDirty: true }
        );
      }
    },
    [externalIds, setValue]
  );

  return (
    <Tooltip
      arrow
      title={
        disabled
          ? `You need the "Edit External Ids" permission to edit this field.`
          : ''
      }
    >
      <span>
        <TextField
          value={
            externalIds?.find((id) => id.type === 'organization')?.value || ''
          }
          onChange={(e) => handleOrgIdChange(e)}
          autoComplete="off"
          label="Employee ID"
          sx={{ minWidth: 400 }}
          disabled={disabled}
        />
      </span>
    </Tooltip>
  );
}
